/* eslint-disable no-underscore-dangle */
import axios from '../../utils/axios';
import { INTERNAL_SERVER_ERROR } from '../../utils/const/http';

const getBulkAssociationTemplate = async () => {
  try {
    const { data } = await axios.get('/api/bulk-association/template', {
      responseType: 'blob',
    });

    return {
      success: true,
      data,
    };
  } catch (err) {
    return {
      success: false,
      error: err,
    };
  }
};

const postBulkAssociationFile = async (url, file) => {
  const formData = new FormData();
  formData.append('file', file);

  try {
    const { data } = await axios.post(url, formData, {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${formData._boundary}`,
      },
    });

    return {
      success: data.success,
      status: data.status,
      data: data.data,
    };
  } catch (err) {
    const status = err.response ? err.response.status : INTERNAL_SERVER_ERROR.status;
    const errorData = err.response?.data?.data || {};

    return {
      success: false,
      status,
      data: {
        errorCode: errorData.errorCode || null,
        errorParams: errorData.errorParams || {},
      },
    };
  }
};

const postValidateBulkAssociationFile = (file) => postBulkAssociationFile('/api/bulk-association/validate', file);

const postLoadBulkAssociationFile = (file) => postBulkAssociationFile('/api/bulk-association/load', file);

export {
  getBulkAssociationTemplate,
  postValidateBulkAssociationFile,
  postLoadBulkAssociationFile,
};
